import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Dialog, DialogTitle, Typography, Button, DialogContent } from "@mui/material";

import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"


import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { FullscreenExit, SettingsPowerRounded } from "@mui/icons-material";
import { selectReportCriteriaEntities } from "../../../reducers/admincenter_reportcriteria";
import { selectReportsForGuid } from "../../../reducers/reference_reportproduct";

import ReportItemDialog from "./ReportItemDialog";
import ReactToPrint, { useReactToPrint } from "react-to-print";





const ReportContainer = () => {
    

    const DataReportStatus = useSelector(state => state.datareports.status)
    const ReportProductsStatus = useSelector(state => state.reportproducts.status)
    const UIReportStatus = useSelector(state => state.uireports.status)
    const ReportCriteria = useSelector(state => selectReportCriteriaEntities(state))
    const ReportArray = useSelector(state => selectReportsForGuid(state, ReportCriteria.ReportGuid))
    const ReportObject = ReportArray && ReportArray[0] ? ReportArray[0] : []


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

   
    /*if (!currentUser) {
      return <Navigate to="/login" />;
    }*/

    useEffect(() => { }, [dispatch, DataReportStatus, UIReportStatus, ReportObject])


    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }

    const thisRef = useRef()

    return ( 

        <Grid container direction="row" spacing={2}>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <ReportItemDialog ref={thisRef}/>
            </Grid>

        </Grid>


    )

};

export default ReportContainer;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */